// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3o_E5","head":"ProcedureTableInfo_head__6-IPF"};